import { InputNumber, type InputNumberProps } from "antd";
import { currencyInputNumberProps } from "./currencyInput";

export const CurrencyInputNumber = (props: InputNumberProps<number>) => (
    <InputNumber<number> {...currencyInputNumberProps} {...props} />
);
